module.exports = __webpack_public_path__ + "img/b-victimsof.ea99c72a.jpg";